import { type FC } from 'react';

import { SIZES } from '@app/constants';

import { Flex, Skeleton } from '@shared/ui-kit';

const MerchantsListLoader: FC = () => {
  return (
    <Flex
      data-testid="merchants-list-loader"
      direction="column"
      rowGap="6"
    >
      {Array(5)
        .fill('')
        .map((_, index) => {
          return (
            <Skeleton
              key={index}
              variant="gray.900"
              height={SIZES.merchantCardHeight}
              borderRadius="md"
              fadeDuration={1}
            />
          );
        })}
    </Flex>
  );
};

export default MerchantsListLoader;
